
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-vaccinations",
      function () {
        return require("private-next-pages/travel-vaccinations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-vaccinations"])
      });
    }
  